export {
  OnboardingQuestionair,
  OnboardingQuestionairProps,
} from './OnboardingQuestionair';
